import { Popup } from 'vant';
import { Component, Vue } from 'vue-property-decorator';
import { ubtButton, moduleExpose } from '@/shared/utils/ubt';
import '@/components/components.theme.blue.scss';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'LivenessSaveDialog' })
export default class LivenessSaveDialog extends Vue {
  private title!: string;

  private scene?: string;

  private resolve!: PromiseResolve<void>;

  private reject!: PromiseReject;

  public isOpen = false;

  public open(title: string, scene?: string): Promise<void> {
    this.isOpen = true;
    this.title = title;
    this.scene = scene;

    moduleExpose(
      'finance_loan_faceID',
      'finance_loan_faceID_retentionPopUp',
      'scene',
      this.scene,
    );
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  public close(): void {
    this.isOpen = false;
  }

  private onCancel() {
    this.close();

    if (this.reject) {
      this.reject();
    }
  }

  private onConfirm() {
    ubtButton(
      'finance_loan_faceID',
      'finance_loan_faceID_retentionPopUp_continue',
      'scene',
      this.scene,
    );
    this.close();
    this.resolve();
  }

  private render() {
    return (
      <Popup
        class={ style.livenessSavePopup }
        v-model={ this.isOpen }
        closeOnClickOverlay={ false }
        position="center"
      >
        {
          this.isOpen
          && <div class={ style.popupPanel }>
            <div class={ style.title }>{ this.title }</div>
            <div class={ style.content }>所有操作遵守国家法律法规，采集的信息仅用于核实您的真实身份</div>
            <div class={ style.btns }>
              <div class={ style.btnPlain } onClick={ this.onCancel.bind(this) }>退出</div>
              <div class={ style.btnPrimary } onClick={ this.onConfirm.bind(this) }>继续验证</div>
            </div>
          </div>
        }
      </Popup>
    );
  }
}
